module.exports = __webpack_public_path__ + "img/REGISTRO 3.b6d97b40.png";